import { styled } from "@mui/material/styles";
import {
    Avatar,
    Box,
    Divider,
    ListItemAvatar,
    ListItemButton,
    Stack,
    Typography,
} from "@mui/material";
import {
    TEXT_ELLIPSIS,
    TEXT_ELLIPSIS_AFTER_TWO_LINES,
} from "../../../../Shared/styles";

export const AvatarContainer = styled("div")({
    position: "relative",
    "& > svg": {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto",
    },
});

export const ListItemAvatarContainer = styled(ListItemAvatar)({
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginTop: "6px",
    marginRight: "12px",
    minWidth: "unset",
});

export const AvatarStyled = styled(Avatar)({
    width: "40px",
    height: "40px",
});

export const TypographyHeaderSubTitleBox = styled(Box)({
    fontSize: "12px",
    color: "var(--community-color-secondary-text)",
    lineHeight: 1.5,
    whiteSpace: "nowrap",
});

export const ListItemButtonContainer = styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== "showHover",
})<{ showHover?: boolean }>(({ showHover = true }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "transparent",
    "&:hover": {
        backgroundColor: showHover ? "rgb(80 115 157 / 5%)" : "transparent",
    },
    padding: "8px 16px",
}));

export const ListItemTextRelatedPost = styled(Typography)({
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "italic",
    color: "var(--community-color-secondary-text)",
    marginBottom: "4px",
    marginTop: "4px",
    ...TEXT_ELLIPSIS_AFTER_TWO_LINES,
    paddingLeft: "8px",
    borderLeft: "1px solid var(--community-color-secondary-text)",
});

export const ListItemMainSection = styled(Stack)({
    flexDirection: "row",
    width: "100%",
});

export const ListItemTextHeadline = styled(Typography)({
    fontSize: "14px",
    fontWeight: 700,
    color: "var(--community-color-primary-text)",
    ...TEXT_ELLIPSIS,
});

export const ListItemTextSubline = styled(Typography)({
    fontSize: "14px",
    fontWeight: 400,
    color: "var(--community-color-primary-text)",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
});

export const DividerCustom = styled(Divider)({
    margin: "0px 16px 0px 68px",
});

export const CountsStack = styled(Stack)({
    flexDirection: "row",
    alignItems: "end",
    gap: "4px",
    marginLeft: "12px",
    height: "100%",
});
